import React from "react"

import Layout from "../../../components/shared/layout"
import Hero from "../../../components/shared/hero"
import { HeroOverlay } from "../../../components/map-editor/hero.style"
import SEO from "../../../components/shared/seo"
import useHeroImages from "../../../components/analytics/useHeroImages"
import UnderstandVisitors from "../../../components/analytics/understand-visitors"
import TrendsInsights from "../../../components/analytics/trends-insights"
import AdditionalBenefits from "../../../components/map-editor/additional-benefits"
import MapEditor from "../../../components/analytics/map-editor"
import ContactUs from "../../../components/shared/contact"
import Footer from "../../../components/shared/footer"

export default function AnalyticsPage({ location }) {
  const images = useHeroImages()
  return (
    <Layout location={location}>
      <SEO
        title="Indoor Maps and Wayfinding Analytics Dashboard"
        description="Mapping Analytics Dashboard tracks usage, map selections and missed searches to better understand the needs of your visitors. "
      />
      <Hero
        overlayStyle={HeroOverlay}
        title={"Analytics Dashboard"}
        sizes={images}
        description={
          "Mappedin’s Analytics Dashboard presents detailed reports on what your property visitors are searching for and where they want to go. This, along with category and language selections, device use, missed searches, and more, provide valuable insights on your users and their intent. "
        }
      />
      <UnderstandVisitors />
      <TrendsInsights />
      <AdditionalBenefits />
      <MapEditor />
      <ContactUs />
      <Footer />
    </Layout>
  )
}
